import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ssp-map-zoom-buttons',
  templateUrl: './map-zoom-buttons.component.html',
  styleUrls: ['./map-zoom-buttons.component.scss', '../../../../../../../../../assets/soti-tooltip.scss'],
})
export class MapZoomButtonsComponent {
  minZoom = 1;
  maxZoom = 22;

  @Input() currentZoom = 6;

  @Output()
  zoomIn = new EventEmitter<null>();

  @Output()
  zoomOut = new EventEmitter<null>();

  zoomInClick() {
    this.currentZoom += 1;
    this.zoomIn.emit(null);
  }

  zoomOutClick() {
    this.currentZoom -= 1;
    this.zoomOut.emit(null);
  }
}
